import React from "react";
import "./style.scss";
import { ButtonGroup, Button, Modal } from "react-bootstrap";

const ModalBox = (props) => {
  const { title, extraClassUpper, disable=false, closeButtonHeader,extraClass, extraBtnStyle, actionbuttontitle, buttonaction, children, type, backbuttontitle, backaction } = props;
  let shouldCloseButton = closeButtonHeader === undefined ? true : closeButtonHeader
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName={extraClassUpper}
    >
      <Modal.Header closeButton={shouldCloseButton}>
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>
      <Modal.Body className={extraClass}>
        {children}
      </Modal.Body>
      {type ?
        <ButtonGroup className='condition-button'>
          <Button className='border-left' disabled={disable} onClick={buttonaction}>{actionbuttontitle}</Button>
          <Button onClick={backaction}>{backbuttontitle}</Button>
        </ButtonGroup> :
        actionbuttontitle &&
        <Modal.Footer className={extraBtnStyle ? 'extraBtnStyle' : ''}>
          <Button onClick={buttonaction} className={"modal-submit-button " + extraBtnStyle} block>{actionbuttontitle}</Button>
          <u style={{ cursor: 'pointer' }} onClick={backaction}>{backbuttontitle}</u>
        </Modal.Footer>}
    </Modal>
  );
}
export default ModalBox;